import moment from "moment";

/** Orders with commenceDate before this date are excluded from 8% SST. */
export const SST_EFFECTIVE_DATE = "2026-07-27";
export const SST_MULTIPLIER = 1.08;
export const SST_RATE = 0.08;

/**
 * Apply 8% SST when sstIncluded is true and commenceDate is not before 2026-07-27.
 */
export function shouldApplySst(commenceDate, sstIncluded) {
    if (sstIncluded !== true) return false;
    if (!commenceDate) return true;
    return !moment(commenceDate).isBefore(SST_EFFECTIVE_DATE, "day");
}

export function applySst(amount, commenceDate, sstIncluded) {
    const n = Number(amount) || 0;
    return shouldApplySst(commenceDate, sstIncluded) ? n * SST_MULTIPLIER : n;
}

export function sstAmount(amount, commenceDate, sstIncluded) {
    const n = Number(amount) || 0;
    return shouldApplySst(commenceDate, sstIncluded) ? n * SST_RATE : 0;
}

/** Invoice total after discount (and SST when enabled). */
export function orderTotalDue(order) {
    const base =
        (Number(order?.amount) || 0) - (Number(order?.discount) || 0);
    return applySst(base, order?.commenceDate, order?.sstIncluded);
}

export function orderBalanceDue(order) {
    const total = orderTotalDue(order);
    const deposit = Number(order?.deposit) || 0;
    return Math.max(0, total - deposit);
}
